import { BaseCmsContentModel } from "../../../models/base-cms-content.model";

export class MarketplaceItemModel extends BaseCmsContentModel {
    public id: string;
    public catalogueId: string;
    public supplierId: string;
    public supplierName: string;
    public imageUrl: string;
    public grossPrice: string;
    public unitOfMeasure: string;
}
